import type { TTheme } from '../models/desktop';

export const OFFSET_HEIGHT = 56;

export const ICON_THEME: Record<TTheme, string> = {
    dark: '#fff',
    light: '#000',
};
